module.exports = __webpack_public_path__ + "img/main_kf.6ec838b4.png";